import { render, staticRenderFns } from "./LeavePageDetailsForm.vue?vue&type=template&id=28460f2e&scoped=true&"
import script from "./LeavePageDetailsForm.vue?vue&type=script&lang=js&"
export * from "./LeavePageDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28460f2e",
  null
  
)

export default component.exports